import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './InfoCard.css';

const InfoCard = ({
  mission,
  editable,
  onChange,
  showActionButton = false,
  onActionClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onActionClick) {
      onActionClick();
    } else {
      navigate(`/recruteur/travailler-mission/${mission._id}`);
    }
  };
  
  // Calcul du temps restant
  const getRemainingTime = () => {
    if (!mission.dateLimite) return null;
    const deadline = new Date(mission.dateLimite);
    const now = new Date();
    const diff = deadline - now;
    if (diff <= 0) return null;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    return { days, hours, minutes };
  };

  const remaining = getRemainingTime();

  return (
    <Card className="info-card-modern">
      <CardContent>
        <div className="info-header-modern">
          <Chip
            label={mission.status === 'active' ? 'PUBLIÉE' : mission.status?.toUpperCase()}
            className={`status-chip ${mission.status === 'active' ? 'green' : 'red'}`}
          />
        </div>
        <Divider className="info-divider-modern" />
        <div className="info-section">
          <Typography className="info-label">Priorité de la mission</Typography>
          {mission.urgenceMission ? (
            <Chip
              label={mission.urgenceMission.toUpperCase()}
              className={`status-chip ${mission.urgenceMission === 'Urgente' ? 'red' : 'green'}`}
            />
          ) : (
            <Typography variant="body2" color="textSecondary">Non spécifiée</Typography>
          )}
        </div>

        <div className="info-section">
          <Typography className="info-label">Prime de la mission</Typography>
          <Typography variant="h5" className="prime-value">
            {mission.remuneration ? `${mission.remuneration} ${mission.devise || '€'}` : 'N/A'}
          </Typography>
        </div>

        <div className="info-section">
          <Typography className="info-label">Date de publication</Typography>
          <Typography variant="body1" fontWeight="bold">
            {mission.dateLimite
              ? new Date(mission.createdAt).toLocaleDateString('fr-FR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })
              : 'Non spécifiée'}
          </Typography>
        </div>
        <div className="info-section">
          <Typography className="info-label">Date limite</Typography>
          <Typography variant="body1" fontWeight="bold">
            {mission.dateLimite
              ? new Date(mission.dateLimite).toLocaleDateString('fr-FR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })
              : 'Non spécifiée'}
          </Typography>
        </div>


        {showActionButton && mission.status === 'active' && (
          <div className="info-button-modern">
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleClick}
              size="medium"
            >
              Proposer un talent
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default InfoCard;
